function api<T>(url: string, options?: RequestInit): Promise<T> {
    return fetch(url, options).then((response) => {
        if (!response.ok) {
            throw new Error(response.statusText);
        }
        const contentType = response.headers.get("Content-Type");
        // @ts-expect-error Check for typing
        if (contentType.includes("application/json")) {
            return response.json() as Promise<T>;
        }
        return response.text() as unknown as Promise<T>;
    });
}

export default api;
